import React from "react";
import { Thumbnail } from "@culturehq/components";

import culturehqbot from "images/badges/culturehqbot.png";

import { t, Trans } from "app/utils";

const AutoRecognizer = () => (
  <div className="recognitions__recognizer">
    <span className="from"><Trans>From: </Trans></span>
    <Thumbnail
      className="Thumbnail"
      image={culturehqbot}
      title={t("CultureBot")}
    />
    <Trans>CultureBot</Trans>
  </div>
);

export default AutoRecognizer;
